// oxlint-disable exhaustive-deps
import useEventCallback from '@unifyapps/hooks/useEventCallback';
import { useMqttClient } from '../../../../../mqtt/hooks/useMqttClient';
import { safeJsonStringify } from '../../../../../utils/json';
import type { ActionHandlerType, OnActionArgs } from '../../../../context/ActionsProvider/context';
import { useGlobalAppStateStore } from '../../../../stores/app/GlobalAppStateStore';
import { useGetNoCodeComputedData } from '../../../computeContext/useGetNoCodeComputedData';
import { SHOULD_NOT_PROPAGATE_UP, SHOULD_PROPAGATE_UP } from '../../const';

function useSendMQTTEvent() {
  const { getNoCodeComputedData } = useGetNoCodeComputedData();

  const interfaceId = useGlobalAppStateStore().hooks.record.useId();
  const mqttTopics = useGlobalAppStateStore().hooks.record.useMqttTopics();

  //do not use useMqttClient hook because for governance pages
  //where user is not logged in , it will throw an error
  //as we mount only when user is logged in, we need to use useContext to avoid error
  const { publish } = useMqttClient({
    returnDummyContext: true,
  });

  const sendMQTTEvent: ActionHandlerType = useEventCallback(
    ({ action, actionContext }: OnActionArgs) => {
      const payload = action.payload as { topicId: string; eventPayload?: unknown };
      const { topicId, eventPayload: unComputedEventPayload } = payload;
      const { value: eventPayload } = getNoCodeComputedData<{
        value: unknown;
      }>(
        {
          value: unComputedEventPayload,
        },
        actionContext,
      );

      const mqttTopic = mqttTopics?.find((topic) => topic.id === topicId);

      if (!mqttTopic?.topic) {
        console.error('MQTT topic not found for ID:', topicId);
        return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
      }
      const message = safeJsonStringify(eventPayload, '');
      publish?.(`${interfaceId}_${mqttTopic.topic}`, message);
      return Promise.resolve(SHOULD_PROPAGATE_UP);
    },
  );

  return { sendMQTTEvent };
}

export default useSendMQTTEvent;
